import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../../style/Menu.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faBus, faCoins, faMoneyBillTrendUp} from '@fortawesome/free-solid-svg-icons';
import { faListCheck } from '@fortawesome/free-solid-svg-icons';
import { faListAlt } from '@fortawesome/free-solid-svg-icons';
import { faTools } from '@fortawesome/free-solid-svg-icons';
import { faList } from '@fortawesome/free-solid-svg-icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';

const Menu = (prop) => {

  const[masterDropDown,SetMasterDropDown] = useState(0);
  const[AssetDropDown,SetAssetDropDown] = useState(0);
  const[ReportDropDown,SetReportDropDown] = useState(0);

  const mastertoggle = ()=>{SetMasterDropDown(1);SetAssetDropDown(0);SetReportDropDown(0);}
  const assettoggle = ()=>{SetMasterDropDown(0);SetAssetDropDown(1);SetReportDropDown(0);}
  const reporttoggle = ()=>{SetMasterDropDown(0);SetAssetDropDown(0);SetReportDropDown(1);}

  useEffect(()=>{
    if(prop.i === "MasterSetup"){
      mastertoggle();
    }else if(prop.i === "Asset"){
      assettoggle();
    }else if(prop.i ==="Report"){
      reporttoggle();
    }
  },[0])
  const P_N = {
    username: prop.username,
    rights: prop.rights
}

  return (
    <div className="menu-bar">
      <div className='menubox'>
        {P_N.rights === "A" ? 
        <Link state={{ username: P_N.username, rights: P_N.rights }} to={'/Dashboard' } className='MenuLinks'><FontAwesomeIcon className="Menuicon" icon={faListCheck}></FontAwesomeIcon><p>Dashboard</p></Link> : 
        <Link state={{ username: P_N.username, rights: P_N.rights }} to={'/ExecutiveDashboard' } className='MenuLinks'><FontAwesomeIcon className="Menuicon" icon={faListCheck}></FontAwesomeIcon><p>Dashboard</p></Link> 
        }
        <div className="dropdown" onClick={mastertoggle}>
          <Link state={{ username: P_N.username, rights: P_N.rights }} className='MenuLinks1'><span style={{display:"flex",alignItems:"center"}}><FontAwesomeIcon className="Menuicon" icon={faListAlt}></FontAwesomeIcon><p>Master Setup</p></span><FontAwesomeIcon className="Menuicon" icon={faAngleDown}></FontAwesomeIcon></Link>
            <div className="dropdown-content" style={{display:masterDropDown === 1 ?"block":"none",zIndex:masterDropDown === 1 ?"0":"1"}}>
                <Link state={{ username: P_N.username, rights: P_N.rights }} to={'/MasterSetup'} className='MenuLinks'><p>Master Page</p></Link>
                <Link state={{ username: P_N.username, rights: P_N.rights }} to={'/Buses'} className='MenuLinks'><p>Buses</p></Link>
                <Link state={{ username: P_N.username, rights: P_N.rights }} to={'/Driver'} className='MenuLinks'><p>Drivers</p></Link>
                <Link state={{ username: P_N.username, rights: P_N.rights }} to={'/Customer'} className='MenuLinks'><p>Customer</p></Link>
                <Link state={{ username: P_N.username, rights: P_N.rights }} to={'/UserManagement'} className='MenuLinks'><p>Login</p></Link>
            </div>
        </div> 
        <Link state={{ username: P_N.username, rights: P_N.rights }} to={'/TripBooking' } className='MenuLinks'><FontAwesomeIcon className="Menuicon" icon={faBus}></FontAwesomeIcon><p>Trip Booking</p></Link>
        <Link state={{ username: P_N.username, rights: P_N.rights }} to={'/TripClosure'} className='MenuLinks'><FontAwesomeIcon className="Menuicon" icon={faCheck}></FontAwesomeIcon><p>Trip Closure</p></Link>
        <Link state={{ username: P_N.username, rights: P_N.rights }} to={'/MaintenanceRecord'} className='MenuLinks'><FontAwesomeIcon className="Menuicon" icon={faTools}></FontAwesomeIcon><p>Maintenance Record</p></Link>
        <Link state={{ username: P_N.username, rights: P_N.rights }} to={'/ExpenseTracker'} className='MenuLinks'><FontAwesomeIcon className="Menuicon" icon={faMoneyBillTrendUp}></FontAwesomeIcon><p>Expense Tracker</p></Link>
        <div className="dropdown" onClick={assettoggle}>
          <Link state={{ username: P_N.username, rights: P_N.rights }} className='MenuLinks1'><span style={{display:"flex",alignItems:"center"}}><FontAwesomeIcon className="Menuicon" icon={faCoins}></FontAwesomeIcon><p>Asset </p></span><FontAwesomeIcon className="Menuicon" icon={faAngleDown}></FontAwesomeIcon></Link>
            <div className="dropdown-content" style={{display:AssetDropDown === 1 ?"block":"none",zIndex:AssetDropDown === 1 ?"0":"1"}}>
            <Link state={{ username: P_N.username, rights: P_N.rights }} to={'/Capital'} className='MenuLinks'><p>Capital</p></Link>
                <Link state={{ username: P_N.username, rights: P_N.rights }} to={'/AssetSetup'} className='MenuLinks'><p>Asset Setup</p></Link>
            </div>
        </div> 
        {P_N.rights === "A" ?
        <div  className="dropdown" onClick={reporttoggle}>
          <Link state={{ username: P_N.username, rights: P_N.rights }} className='MenuLinks1'><span style={{display:"flex",alignItems:"center"}}><FontAwesomeIcon className="Menuicon" icon={faList}></FontAwesomeIcon><p>Report</p></span><FontAwesomeIcon className="Menuicon" icon={faAngleDown}></FontAwesomeIcon> </Link>
            <div className="dropdown-content" style={{display:ReportDropDown === 1 ?"block":"none"}}>
                <Link state={{ username: P_N.username, rights: P_N.rights }} to={'/ExpenseReport'} className='MenuLinks'><p>Expense Report</p></Link>
                <Link state={{ username: P_N.username, rights: P_N.rights }} to={'/MaintenanceReport'} className='MenuLinks'><p>Maintenance Report</p></Link>
            </div>
        </div> : null}
        </div>
    </div>
  );
};

//<Link state={{ username: P_N.username, rights: P_N.rights }} className='MenuLinks'><p>Booking Report</p></Link>


export default Menu;
